import { render, staticRenderFns } from "./NirEntityViewPage.vue?vue&type=template&id=24e0ba8d&scoped=true&"
import script from "./NirEntityViewPage.vue?vue&type=script&lang=js&"
export * from "./NirEntityViewPage.vue?vue&type=script&lang=js&"
import style0 from "./NirEntityViewPage.vue?vue&type=style&index=0&id=24e0ba8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0ba8d",
  null
  
)

export default component.exports